import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Work, WorkOutline } from '@material-ui/icons';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { FORM_MAX_WIDTH, SelectEntityOption } from '../../../utils/constants';
import { OneToolCard } from './oneToolCard';

const useStyles = makeStyles(theme => ({
  button: {
    width: '358px',
    margin: '0 auto',
    border: '1px solid rgba(88, 171, 222, 1)',
    boxShadow: 'box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);',
    color: 'black',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 400,
  },
}));

interface CardProps {
  option: string;
  onSelect: (option: string) => void;
}

export const citizenshipStatusOptions = [
  { label: 'US Citizen', value: 'US Citizen' },
  {
    label: 'US Permanent Resident',
    value: 'US Resident with Valid Visa',
  },
  {
    label: 'Foreign National',
    value: 'Foreign National',
  },
];

export const SelectCitizenshipOptionCard = observer(
  ({ option, onSelect }: CardProps) => {
    const classes = useStyles();
    return (
      <OneToolCard
        maxWidth={FORM_MAX_WIDTH}
        center
        title={'Please confirm your residency status'}
      >
        <Grid container spacing={2} direction="column" alignItems="center">
          {citizenshipStatusOptions.map(option => (
            <Grid item>
              <Button
                testId="search-existing"
                variant="outlined"
                color="primary"
                fullWidth
                className={classes.button}
                onClick={() => onSelect(option.value)}
              >
                {option.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </OneToolCard>
    );
  }
);
